module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-theme-4-4de77da5e6efab8ad92086e5a5474503.webp";